import { render } from "./Dummy.vue?vue&type=template&id=226daaa7"
import script from "./Dummy.vue?vue&type=script&lang=js"
export * from "./Dummy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__